import React from 'react';
import { BriefCreationTextArea } from '@fiverr-private/dm_brief_creation';
import { CurrencyType, DEFAULT_CURRENCY } from '../utils';

interface PredefinedTag {
    title: string;
    prompt: string;
}

interface DmBriefCreationTextAreaProps {
    source: string;
    currencyObject?: CurrencyType;
    isDefaultHourly?: boolean;
    autoSubmitOnSignUp?: boolean;
    predefinedTags?: PredefinedTag[];
}

const DmBriefCreationTextArea = ({
    source,
    currencyObject,
    isDefaultHourly,
    autoSubmitOnSignUp,
    predefinedTags,
}: DmBriefCreationTextAreaProps) => {
    const currencyOrDefault = currencyObject || DEFAULT_CURRENCY;

    return (
        <BriefCreationTextArea
            currency={currencyOrDefault}
            source={source}
            isDefaultHourly={isDefaultHourly}
            autoSubmitOnSignUp={autoSubmitOnSignUp}
            predefinedTags={predefinedTags}
            rollouts={{ inMustangsPersonBrief: true }}
        />
    );
};

export default DmBriefCreationTextArea;
